import { createRoot } from 'react-dom/client'
import { ConvexAuthProvider } from '@convex-dev/auth/react'
import { ConvexReactClient } from 'convex/react'
import { ThemeProvider } from '@/components/theme/ThemeProvider'
import App from './App.tsx'
import './index.css'
import './utils/uatHealthCheck'

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string)

// Initialize UAT health checks and performance test suite in development
if (import.meta.env.DEV) {
  console.log('UAT Health Check system enabled')
  // Initialize performance tracking flag
  window.__VRP_PERF_STARTED = false

  // Load performance test suite for manual console testing
  import('./utils/perfDebug-test-suite').then(module => {
    ;(window as any).runPerfDebugTests = module.runPerfDebugTests
    console.log('Performance test suite loaded. Run: runPerfDebugTests()')
  })
}

// Global error handler to suppress browser extension message channel errors
window.addEventListener('error', event => {
  // Suppress browser extension message channel errors
  if (
    event.error?.message?.includes(
      'message channel closed before a response was received'
    ) ||
    event.error?.message?.includes(
      'A listener indicated an asynchronous response by returning true'
    )
  ) {
    event.preventDefault()
    event.stopPropagation()
    return false
  }
})

// Handle unhandled promise rejections from browser extensions
window.addEventListener('unhandledrejection', event => {
  // Suppress browser extension message channel errors
  if (
    event.reason?.message?.includes(
      'message channel closed before a response was received'
    ) ||
    event.reason?.message?.includes(
      'A listener indicated an asynchronous response by returning true'
    )
  ) {
    event.preventDefault()
    return false
  }
})

createRoot(document.getElementById('root')!).render(
  <ConvexAuthProvider client={convex}>
    <ThemeProvider defaultTheme="light" storageKey="vrp-theme">
      <App />
    </ThemeProvider>
  </ConvexAuthProvider>
)
// Rebuild trigger Thu Oct 23 19:20:46 SAST 2025
